import React , {Component} from 'react';
import { connect } from "react-redux";
import NumberFormat from 'react-number-format';
import buttonPlusIcon from './../../assets/images/icons/button-plus.svg';
import buttonMinusIcon from './../../assets/images/icons/button-minus.svg';

import {addToUserCart  , addToCart  , removeFromUserCart , removeFromCart  } from "./../../../actions";
class ProductInCartCard extends Component{

    buttonPlusHandler(){
        this.props.addToCart(this.props.product.id)
        this.props.addToUserCart(this.props.product.id)
        this.props.cartHandler()
    }

    buttonMinusHandler(){
        this.props.removeFromCart(this.props.product.id)
        this.props.removeFromUserCart(this.props.product.id)
        this.props.cartHandler()
    }

    render(){
        const { product } = this.props
        /*let qty = product.qty
        if (!isNaN(this.props.cart[product.id]) || this.props.cart[product.id] !== undefined )
        {
            qty = this.props.cart[product.id]
        }*/
        let qty = this.props.qty

        let daily_stock_count_sens_status = false
        let daily_stock_count = 0
        let daily_stock_text = ''
        if (product.daily_stock_count_sens_status === true) {
            daily_stock_count_sens_status = true;
            daily_stock_count = product.daily_stock_count
            daily_stock_text =   product.daily_stock_count + ' عدد باقی مانده'
        }

        let orderInPreOrder = localStorage.getItem("orderInPreOrder") !== null && localStorage.getItem("orderInPreOrder") == 'true'

        return (
            <div className="card-custom-6">
                <div className="row no-gutters">
                    <div className="col-auto pl-1">
                        <div className="img-container">
                            <img className="item-icon" src={product.imagePreview} alt={product.title} />
                        </div>
                    </div>

                    <div className="col pr-1">
                        <div className="row justify-content-between align-items-center">
                            <div className="col-auto">
                                <div className="title">
                                    {product.title}
                                </div>
                                {daily_stock_count_sens_status === true && !orderInPreOrder ?  (
                                    <div className="stock-count">
                                        {daily_stock_text}
                                    </div>
                                ) : ''}
                                {
                                    product.price !== product.priceWithDiscount ?
                                        (
                                            <div className="price-container has-discount">
                                                <div className="price d-inline-block">
                                                    <NumberFormat value={product.price} displayType={'text'} thousandSeparator={true}  />
                                                </div>
                                                <div className="price-with-discount  d-inline-block">
                                                    <NumberFormat value={product.priceWithDiscount} displayType={'text'} thousandSeparator={true}  />
                                                    <span className="currency">
                                                        تومان
                                                    </span>
                                                </div>
                                            </div>
                                        ) :
                                        (
                                            <div className="price-container">
                                                <div className="price-with-discount">

                                                    <NumberFormat value={product.priceWithDiscount} displayType={'text'} thousandSeparator={true}  />
                                                    <span className="currency">
                                                        تومان
                                                    </span>
                                                </div>
                                            </div>
                                        )
                                }
                            </div>
                            <div className="col-auto">
                                <div className="qty-container">

                                    <div className="button-minus-container">
                                        <button className="btn btn-custom-1" onClick={this.buttonMinusHandler.bind(this)}>
                                            <img src={buttonMinusIcon} alt="button-minus"/>
                                        </button>
                                    </div>

                                    <div className="qty-count-container">
                                        {qty}
                                    </div>

                                    <div className="button-plus-container">
                                        <button className="btn btn-custom-1" onClick={this.buttonPlusHandler.bind(this)}>
                                            <img src={buttonPlusIcon} alt="button-plus"/>
                                        </button>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}


const mapDispatchToProps = dispatch => ({
    addToCart : productId => dispatch(addToCart(productId)) ,
    addToUserCart : productId => dispatch(addToUserCart(productId)) ,


    removeFromCart : productId => dispatch(removeFromCart(productId)) ,
    removeFromUserCart : productId => dispatch(removeFromUserCart(productId)) ,
})

const mapStateToProps = state => {
    return {
        products : state.products ,
        cart : state.cart ,
    }
}

export default connect( mapStateToProps , mapDispatchToProps)(ProductInCartCard);